/**
 * Shadcn-styled native ``<select>``. We use this over Radix Select for
 * forms where the simpler native control gives us better mobile + touch
 * behaviour for free, with no a11y concerns to manage.
 */
import { forwardRef, type SelectHTMLAttributes } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

export type SelectNativeProps = SelectHTMLAttributes<HTMLSelectElement>;

export const SelectNative = forwardRef<HTMLSelectElement, SelectNativeProps>(
  function SelectNative({ className, children, ...props }, ref) {
    return (
      <div className="relative">
        <select
          ref={ref}
          className={cn(
            "flex h-9 w-full appearance-none rounded-md border border-input bg-background px-3 pr-9 text-sm shadow-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            className,
          )}
          {...props}
        >
          {children}
        </select>
        <ChevronDown
          aria-hidden
          className="pointer-events-none absolute right-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
        />
      </div>
    );
  },
);
